<template>
  <div>
    <b-modal
      id="modal-1"
      :title="title"
      @ok="action"
      ref="modal"
    >
      <the-body />
    </b-modal>
  </div>
</template>

<script>
import TheBody from './TheBody'

export default {
  components: {
    TheBody
  },

  data () {
    return {
      modelName: 'modal'
    }
  },

  computed: {
    title () {
      return this.$store.getters[`${this.modelName}/getAttr`]('title')
    },

    action () {
      return this.$store.getters[`${this.modelName}/getAttr`]('action')
    }
  },

  mounted () {
    this.$store.commit(`${this.modelName}/setAttr`, {
      name: 'element',
      value: this.$refs.modal
    })
  }
}
</script>
